import { Component, Input, Output, ContentChildren, QueryList, EventEmitter, ViewChild } from '@angular/core';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { MatButton } from '@angular/material/button';
import { GridSpinnerComponent } from './grid-spinner.component';

@Component({
  selector: 'cw-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
  @Input() title : string;
  @Input() subTitle: string;
  @Input() showCloseButton : boolean;
  @Input() showLogo = true;
  @ContentChildren(MatButton) buttons: QueryList<MatButton>;
  @ViewChild('spinner', { static: true }) spinner: GridSpinnerComponent;
  @Output() eventHandler: EventEmitter<any> = new EventEmitter();

  constructor(public themeManager: ThemeManagerService) {
  }

  public onCloseIcon() {
    this.eventHandler.emit({ state: 'CLOSECLICKED' });
  }
}